import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import React, { useEffect, useState } from "react";
import DonutChart from "../../Layouts/Graphs/DonutChart";
import CompletionTrendGraphNew from "../ReportsComponents/CompletionTrendGraphNew";
import TrendChart from "../../../utils/TrendChart";
import TrendChartSingle from "../../../utils/TrendChartSingle";
import SummaryComponent from "./SummaryComponent";
import DonutTrendChartComponent from "./DonutTrendChartComponent";
import _ from "lodash";

const ReportGraphComponent = (props) => {

    const {
        trendYear,
        loadChart,
        seriesAll,
        legendsAll,
        trendValues,
        listingData,
        seriesSingle,
        legendsSingle,
        trendLoadChart,
        filterYearData,
        trendFilterCourses,
        overAllLearningPoints,
        trendValueSingle,
        setYear,
        setLoadChart,
        setImgLoader,
        getCompletionTrend,
        filterYearDataOfSingle,
        isDetail,
        check,
        ExportToExcel,
        isLp,
        courseOrVideo
    } = props

    const [selectedCourseName, setSelectedCourseName] = useState("");
    const [isDonutSingleEmpty, setIsDonutSingleEmpty] = useState(false)

    useEffect(() => {
        console.log('seriesSingle: ', seriesSingle)
        if (_.isArray(seriesSingle)) {
            let flag = true;
            for (let r of seriesSingle) {
                if (_.toNumber(r) !== 0) {
                    flag = false;
                }
            }
            console.log('seriesSingle1: ', flag)
            if (flag) {
                setIsDonutSingleEmpty(true)
            }
            return (() => {
                setIsDonutSingleEmpty(false)
            })
        }
    }, [seriesSingle])



    return (
        <section className="progress-report-data">
            <div className="container-pwc">
                {isDetail && <div className="row">
                    <div className="col-md-12">
                        <div className="report-download" onClick={() => { ExportToExcel() }}>
                            <svg id="Component_115_14" data-name="Component 115 â 14"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                width="45"
                                height="45"
                                viewBox="0 0 30 30">
                                <defs>
                                    <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
                                        <stop offset="0" stop-color="#415385" />
                                        <stop offset="1" stop-color="#415385" />
                                    </linearGradient>
                                </defs>
                                <circle id="Ellipse_57" data-name="Ellipse 57" cx="15" cy="15" r="15" fill="url(#linear-gradient)" />
                                <circle id="Ellipse_179" data-name="Ellipse 179" cx="14" cy="13" r="14" transform="translate(1 2)" fill="#fff"></circle>
                                <path id="database-export" d="M9.62,3C6.515,3,4,4.257,4,5.81S6.515,8.62,9.62,8.62c.351,0,.7-.021,1.054-.056v-1H12.7l-.7-.7,2.466-2.459A7.748,7.748,0,0,0,9.62,3m4.861,2.866-1,1L15.24,8.62H11.728v1.405H15.24l-1.756,1.756,1,1,3.456-3.456M4,7.215V9.323c0,1.553,2.515,2.81,5.62,2.81a10.5,10.5,0,0,0,2.283-.26l.794-.794H10.674V9.969c-.351.035-.7.056-1.054.056C6.515,10.025,4,8.768,4,7.215m0,3.513v2.108c0,1.553,2.515,2.81,5.62,2.81a7.748,7.748,0,0,0,4.847-1.405l-1.335-1.335a9.473,9.473,0,0,1-3.513.632C6.515,13.538,4,12.28,4,10.728Z" transform="translate(4.6 5.677)" fill="#415385" />
                            </svg>
                        </div>
                    </div>
                </div>}

                <SummaryComponent
                    total_percentage={overAllLearningPoints?.total_percentage ? overAllLearningPoints?.total_percentage : 0}
                    total_assigned={overAllLearningPoints?.total_assigned ? overAllLearningPoints?.total_assigned : 0}
                    total_completed={overAllLearningPoints?.total_completed ? overAllLearningPoints?.total_completed : 0}
                    week_progress={overAllLearningPoints?.from_last_week_completion_progress ? overAllLearningPoints?.from_last_week_completion_progress : 0}
                    check={check}
                    isLp={isLp}
                    courseOrVideo={courseOrVideo}
                />

                {false&&<DonutTrendChartComponent
                    blockTitle={''}
                    dropDownLabel={'Select Year'}
                    dropDownArray={filterYearData}
                    selectDropDown={setYear}
                    loader={trendLoadChart}
                    setLoader={setImgLoader}
                    donutTitle={'Completion Status'}
                    series={seriesAll}
                    legends={legendsAll}
                    selectedTitle={'2023'}
                    trendTitle={'Completion Trend'}
                    trendValues={trendValues}
                    useTrendValues={false}
                    completionTrendYAxisLabel={''}
                />}

                {!isDetail && false && <div className="row mt-4">
                    <div className="col-md-12">
                        <div className="reports-chart graph-box-learnong shadow-box-report">
                            <div className="d-flex justify-content-between align-items-center gap-2 mb-3">
                                <div className="chart-heading-report mb-0">
                                    {isLp ? check ? "Onboarding" : "Action Path" : "Course"} wise Status
                                </div>
                                <div className="input-text fliterreportsgen">
                                    <label htmlFor="filter" className="input__label">
                                        Select {isLp ? check ? "Onboarding" : "Action Path" : "Course"}
                                    </label>
                                    <select id="course_filter" name="course_filter" class="form-select input_searchfield mb-0 session-filter"
                                        onChange={(e) => {
                                            const selectedCourse = e.target.value;
                                            let index = trendFilterCourses.findIndex(x => x.id === selectedCourse);

                                            if (selectedCourse === 'all') {
                                                getCompletionTrend(listingData)
                                                setSelectedCourseName("")
                                            } else {
                                                setSelectedCourseName(trendFilterCourses[index].name)
                                                getCompletionTrend([selectedCourse])
                                            }
                                            setImgLoader(true)
                                        }} >
                                        <option value="all">All</option>
                                        {trendFilterCourses?.map((item, index) => {
                                            return <option value={item.id}>{item.name}</option>
                                        }
                                        )}
                                    </select>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-lg-5 col-xl-4">
                                    <div className="graph-box-learnong grah-center justify-content-start position-relative graphbox">
                                        <div className="proglefttext">{selectedCourseName}</div>
                                        {
                                            isDonutSingleEmpty ?
                                                <div className="graph-box-learnong donut-empty">
                                                    <div
                                                        className="circularProgress"
                                                        style={{
                                                            width: 115,
                                                            height: 115,
                                                            position: "relative",
                                                        }}
                                                    >
                                                        <CircularProgressbar
                                                            value={0}
                                                            strokeWidth={25}

                                                            styles={buildStyles({
                                                                pathColor: "#415385", //FF9700=yellow
                                                                trailColor: "#EBEBEB",
                                                                strokeLinecap: 'butt',
                                                            })}
                                                        />
                                                        <div
                                                            style={{
                                                                position: "absolute",
                                                                top: "0",
                                                                width: "150px",
                                                                bottom: "0",
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                                textAlign: "center",

                                                            }}
                                                        ></div>
                                                    </div>
                                                </div> : ""
                                        }
                                        <DonutChart series={seriesSingle}
                                            legends={legendsSingle} />
                                    </div>

                                </div>
                                <div className="col-md-12 col-lg-7 col-xl-8">
                                    <div className="graph-box-learnong">
                                        <div className="proglefttext">{selectedCourseName}{_.isEmpty(selectedCourseName) ? "" : " -"} Completion Trend</div>
                                        <div className="completion-tranding-graph">
                                            {loadChart ? "" : true && trendValueSingle.length > 0 ?
                                                <CompletionTrendGraphNew
                                                    crsCompltTrendData={trendValueSingle}
                                                    // crsCompltTrendData={[2,20,40,0,0,60,0,0,0,0,0,0]}
                                                    completionTrendLabel={isLp ? (check ? "Onboarding Completion" : "Action Path Completion") : (check ? "Compliance Courses Completion" : "Learning Course Completion")}
                                                    crsCompltTrend={filterYearDataOfSingle}
                                                    setYear={setYear}
                                                    trendYear={trendYear}
                                                    setImgLoader={setImgLoader}
                                                    setLoaderChart={setLoadChart}
                                                    loaderChart={loadChart}
                                                />
                                                : ""}
                                            {loadChart ? "" : false && trendValueSingle.length > 0 ?
                                                <TrendChartSingle trendValue={trendValueSingle} /> : ""}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}

                {/* <p><strong>Last updated on  </strong>{ getDateTime(totalRea?.last_updated, userDetails)}</p> */}

            </div>
            {/* <div id="myOnboard" class="center_line"></div> */}
        </section>
    )
}

export default ReportGraphComponent